export const PLATFORM_REPORT_ACTIONS = {
    PLATFORM_CAMPAIGNS_LOADING: "PLATFORM_CAMPAIGNS_LOADING",
    PLATFORM_CAMPAIGNS_LOADED: "PLATFORM_CAMPAIGNS_LOADED",  // Ensure the type is correct here
    PLATFORM_CAMPAIGNS_FAILURE: "PLATFORM_CAMPAIGNS_FAILURE"
  };

